"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var createContainer_1 = (0, tslib_1.__importDefault)(require("./createContainer"));
var Lifetime_1 = (0, tslib_1.__importDefault)(require("./constants/Lifetime"));
var registrations_1 = (0, tslib_1.__importDefault)(require("./registrations"));
exports.default = (0, tslib_1.__assign)({ createContainer: createContainer_1.default, Lifetime: Lifetime_1.default }, registrations_1.default);
//# sourceMappingURL=index.js.map